
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Users, Trash2 } from "lucide-react";
import { EnhancedUser } from "./EnhancedUsersSection";
import { getUserTypeLabel, getUserTypeBadgeVariant, type UserType } from "@/utils/userTypes";

interface UserTableViewProps {
  users: EnhancedUser[];
  isLoading: boolean;
  onUserClick: (userId: string) => void;
  onDeleteUserClick: (userId: string) => void;
  isDeleting?: boolean;
}

export const UserTableView = ({ users, isLoading, onUserClick, onDeleteUserClick, isDeleting = false }: UserTableViewProps) => {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Loading Users...</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex items-center space-x-4 animate-pulse">
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                </div>
                <div className="h-6 bg-gray-200 rounded w-20"></div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Type</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id} className="hover:bg-muted/50">
              <TableCell 
                className="cursor-pointer"
                onClick={() => onUserClick(user.id)}
              >
                <div className="font-medium">
                  {user.first_name} {user.last_name}
                </div>
              </TableCell>
              <TableCell 
                className="text-sm text-muted-foreground cursor-pointer"
                onClick={() => onUserClick(user.id)}
              >
                {user.email}
              </TableCell>
              <TableCell 
                className="text-sm text-muted-foreground cursor-pointer"
                onClick={() => onUserClick(user.id)}
              >
                {getUserTypeLabel(user.device_management_type as UserType)}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-8 w-8 p-0 text-destructive hover:text-destructive"
                  disabled={isDeleting}
                  onClick={() => onDeleteUserClick(user.id)}
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
